"use client"
import {
  Card,
  CardContent,
  CardFooter,
  CardFooterSection,
  classNames,
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
} from "@opensea/ui-kit"
import { useAspectRatio } from "./card/ItemCardMedia/ItemCardMediaAspectRatio"
import { useItemView } from "./ItemViewProvider"

type Props = {
  overrides?: {
    Skeleton?: {
      className?: string
    }
  }
}

export function GridItemSkeleton({ overrides }: Props) {
  const { itemView } = useItemView()
  const { aspectRatio } = useAspectRatio()

  return (
    <Card className="pointer-events-none">
      <CardContent>
        <SkeletonBlock
          className={overrides?.Skeleton?.className}
          style={{ aspectRatio }}
        />
      </CardContent>

      {itemView !== "mosaic" && (
        <CardFooter>
          <Skeleton>
            <CardFooterSection className="h-auto pt-3.5">
              <SkeletonLine
                className={classNames("w-3/4", overrides?.Skeleton?.className)}
              />
            </CardFooterSection>
            <CardFooterSection>
              <SkeletonLine
                className={classNames("w-1/3", overrides?.Skeleton?.className)}
              />
            </CardFooterSection>
          </Skeleton>
        </CardFooter>
      )}
    </Card>
  )
}
